const MASK_CLASS = 'ph-loading'

function init(el, binding) {
  if (!binding.value) {
    removeLoadingMask(el)
  } else {
    addLoadingMask(el)
  }
}

function removeLoadingMask(el) {
  const mask = el.querySelector(`.${MASK_CLASS}`)
  if (mask) {
    mask.style.display = 'none'
  }
}

function addLoadingMask(el) {
  const mask = el.querySelector(`.${MASK_CLASS}`)
  if (mask) {
    mask.style.display = 'block'
  } else {
    const n = document.createElement('div')
    n.innerHTML = `<div class="${MASK_CLASS}"></div>`
    el.prepend(n.firstChild)
  }
}

const loading = {
  name: 'ph-loading',
  bind: init,
  mounted: init,
  update: init
}

export default loading
